export default __webpack_public_path__ + "static/media/biomalogo.e09c0daf.png";